module.exports = __webpack_public_path__ + "img/img3.495d8dfa.png";